import { AUDIO_SOURCE_WILL_CHANGE } from '../utils/audioProgressRecorder';

const pendingSeeks = new WeakMap();

export const cancelPendingAudioSeek = audio => {
    const listener = pendingSeeks.get(audio);
    if (listener) {
        audio.removeEventListener('loadeddata', listener);
        pendingSeeks.delete(audio);
    }
};

export const loadTrack = (mp3URL, setTime, norefresh) => {
    const audio = document.getElementById('audio');
    if (!norefresh || audio.src !== mp3URL) {
        audio.dispatchEvent(new Event(AUDIO_SOURCE_WILL_CHANGE));
        cancelPendingAudioSeek(audio);
    }
    if (!norefresh) {
        audio.pause();
        audio.src = '';
    }
    if (audio.src !== mp3URL) {
        audio.src = mp3URL;
        const requestedSource = audio.src;
        audio.currentTime = setTime;
        const playRequest = audio.play();
        playRequest.catch(function () {
            // Browser doesn't allow play until user click.
        });

        if (setTime !== undefined) {
            const applySeek = () => {
                pendingSeeks.delete(audio);
                if (audio.src !== requestedSource) {
                    return;
                }
                audio.currentTime = setTime;
                if (localStorage.PLAYBACK_RATE) {
                    audio.playbackRate = localStorage.PLAYBACK_RATE
                }
                if (!audio.paused) {
                    audio.play().catch(function () {
                        // Browser doesn't allow play until user click.
                    });
                }
            };
            pendingSeeks.set(audio, applySeek);
            audio.addEventListener('loadeddata', applySeek, { once: true});
        }
        return playRequest;
    }
}
